import {roomSettingService} from "@/core/service/room.setting.service";
import {BaseApi} from "@/core/api/base.api";
import {Room} from '@/core/api/room.api'

class RoomSettingApi extends BaseApi {
    constructor() {
        super()

        Room.Setting = this

        Room.ready(async e => {
            this._eventListen(this.#Events)
        })
    }

    async changeCameraRole(cameraOn) {
        return await roomSettingService.changeCameraRole(cameraOn)
    }
    async changeMicRole(micOn) {
        return await roomSettingService.changeMicRole(micOn)
    }
    async changeResetRole(reset) {
        return await roomSettingService.changeResetRole(reset)
    }
    async changeDefaultRoleId(defaultRoleId) {
        return await roomSettingService.changeDefaultRoleId(defaultRoleId)
    }
    async changeDefaultDevice(defaultDevice) {
        return await roomSettingService.changeDefaultDevice(defaultDevice)
    }
    async changeChatMode(chatMode) {
        return await roomSettingService.changeChatMode(chatMode)
    }
    async changeWaitingMode(waitingMode) {
        return await roomSettingService.changeWaitingMode(waitingMode)
    }
    async changeDeviceRequired(waitingMode) {
        return await roomSettingService.changeDeviceRequired(waitingMode)
    }
    async changeTranslateMode(translateMode) {
        return await roomSettingService.changeTranslateMode(translateMode)
    }
    async changeStickerMode(stickerMode) {
        return await roomSettingService.changeStickerMode(stickerMode)
    }
    async changeDocMargin(docMargin) {
        return await roomSettingService.changeDocMargin(docMargin)
    }
    async changeQuality(quality){
        return await roomSettingService.changeQuality(quality)
    }
    async changeUseQnA(useQnA) {
        return await roomSettingService.changeUseQnA(useQnA)
    }
    async changeUseQnAShare(useQnAShare){
        return await roomSettingService.changeUseQnAShare(useQnAShare)
    }
    getRoomSetting() {
        let roomData = Room.getRoomData()
        return roomData.roomInfo['setting']
    }
    #Events = {
        room_setting_change_cameraRole(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['defaultRoleCamera'] = e.data['defaultRoleCamera']
            Room.emit(e)
        },
        room_setting_change_micRole(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['defaultRoleMic'] = e.data['defaultRoleMic']
            Room.emit(e)
        },
        room_setting_change_resetRole(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['defaultRoleReset'] = e.data['defaultRoleReset']
            Room.emit(e)
        },
        room_setting_change_defaultRoleId(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['defaultRoleId'] = e.data['defaultRoleId']
            Room.emit(e)
        },
        room_setting_change_defaultDevice(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['defaultDeviceType'] = e.data['defaultDeviceType']
            Room.emit(e)
        },
        room_setting_change_chatMode(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['useChat'] = e.data['useChat']
            Room.emit(e)
        },
        room_setting_change_waitingMode(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['useWaitingMode'] = e.data['useWaitingMode']
            Room.emit(e)
        },
        room_setting_change_deviceRequired(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['isDeviceRequired'] = e.data['isDeviceRequired']
            Room.emit(e)
        },
        room_setting_change_translateMode(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['useTranslate'] = e.data['useTranslate']
            Room.emit(e)
        },
        room_setting_change_stickerMode(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['useSticker'] = e.data['useSticker']
            Room.emit(e)
        },
        room_setting_change_docMargin(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['useDocMargin'] = e.data['useDocMargin']
            Room.emit(e)
        },
        room_setting_change_useQnA(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['useQnA'] = e.data['useQnA']
            Room.emit(e)
        },
        room_setting_change_useQnAShare(e) {
            let roomSetting = this.getRoomSetting()
            roomSetting['useQnAShare'] = e.data['useQnAShare']
            Room.emit(e)
        },
    }

}

export const RoomSetting = new RoomSettingApi()